import { observer } from "mobx-react-lite";
import { SelectField } from "@/components/common";
import { useTran } from "@/hooks";
import { authSessionStore } from "@/features/auth/stores/auth-session.store";
import { hasParentAccess } from "@/features/esg/utils/org-scope.utils";

const ALL = "__all__";

const CategoryFilter = observer(({ value, onChange }) => {
  const { t } = useTran();
  const showGeneral = hasParentAccess(authSessionStore.user);
  const categories = showGeneral
    ? ["Environmental", "Social", "Governance", "General"]
    : ["Environmental", "Social", "Governance"];

  const options = [
    { value: ALL, label: t("All Categories") },
    ...categories.map((c) => ({ value: c, label: t(c) })),
  ];

  return (
    <SelectField
      label={t("Category")}
      options={options}
      value={value || ALL}
      onValueChange={(v) => onChange(v === ALL ? "" : v)}
      sortOptions={false}
      placeholder={t("All Categories")}
      className="w-full sm:w-40"
    />
  );
});

export default CategoryFilter;
